import React from "react";
import { AiOutlinePoweroff } from "react-icons/ai";
import { logOut } from "../../helpers/authFunctions";
import { LOCAL_IMAGE } from "../../images/ImageConstant";
import { IoPower } from "react-icons/io5";

function LogoNavbar() {
  return (
    <div className="py-5 bg-white px-5 flex  justify-between">
      <img src={LOCAL_IMAGE.LOGO} />
      <button
        onClick={logOut}
        className="flex border-[1.5px] px-5 border-[#005eb8]  rounded-full text-[#005eb8] font-medium items-center"
      >
        <IoPower className="mx-1" />
        Logout
      </button>
    </div>
  );
}

export default LogoNavbar;
